<!--正常下单-->
<template>
  <div class="catcheck">
    <cube-page type="catcheck-view" title="提交订单">
      <div slot="content" class="content-order">
        <div class="content-main">
          <div class="leoAddLkclass">
            <div class="title-top ells2" v-if="detail">{{detail.goods_name || '--'}}</div>
            <LeoCalendar v-if="iscalender" @confirm="confirm" :deData="deDataP" :useDate="beg_Date"></LeoCalendar>
            <van-field v-model="remarks" type="textarea" maxlength="50" show-word-limit
              placeholder="如航班信息/上车点/用车时间等告知平台。" label="备注" label-class="bztitle"></van-field>
            <div class="yktitle">
              <div class="title">游客规则</div>
              <div class="rematk">
                <van-radio-group v-model="order_type" direction="horizontal" @change="onRadio">
                  <van-radio name="10" :disabled="isOne==20">一证一人</van-radio>
                  <van-radio name="20" :disabled="isOne==10">一证多人</van-radio>
                </van-radio-group>
              </div>
            </div>
          </div>
        </div>
        <div v-if="getGoodsSkusPrice.length > 0">
          <van-collapse v-model="activeName" accordion class="collapse-zdy">
            <van-collapse-item :title="item.group_name" :name="item.index" v-for="item in getGoodsSkusPrice"
              :key="item.group_id">
              <div class="ddcheck">
                <div class="introduction">
                  <div class="introduction-main" v-for="(treelist,index) in item.items" :key="index">
                    <div class="introduction-title">
                      <div class="left">{{treelist.item_name}}</div>
                      <div class="right" :class="treelist.price ? '':'no'">￥{{treelist.price || 'null'}}</div>
                    </div>
                    <!-- 数量选择和游客 -->
                    <div class="content">
                      <leoAddLk @onChangeNum="ChangeNum" @YkSubmit="YkSubmit" :cardMust="cardMust"
                        :gmxzData="treelist.notice_text" :ordertype="order_type" :skulistprice="treelist.price"
                        :skuid="treelist.spec_sku_id" :columns="columns" :stock="treelist.stock" :groupid="item.group_id" :priceRetail="treelist.priceRetail" :treelist="treelist">
                      </leoAddLk>
                    </div>
                  </div>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
        <van-submit-bar :price="totalPrice*100" button-text="提交订单" @submit="onSubmit" :loading="disabled"
          text-align="left" style="box-shadow: 0px -5px 3px #f1f1f1;"></van-submit-bar>
        <cube-view></cube-view>
      </div>
    </cube-page>
    <!--购买须知-->
    <Gmxz ref="gmxz" />
  </div>
</template>

<script>
  import CubePage from "../TP/cube-page.vue";
  import CubeView from "@/components/TP/cube-view";
  import LeoCalendar from "@/components/TP/leoCalendarNew";
  import leoAddLk from "@/components/TP/leoAddLkNew";
  import * as util from "@/utils/network";
  import Gmxz from "../NewPages/gmxz.vue";
  import {
    Dialog
  } from "vant";
  export default {
    components: {
      CubePage,
      CubeView,
      LeoCalendar,
      leoAddLk,
      Gmxz
    },
    data() {
      return {
        activeName: '1', // 手风琴
        isOne: "", // 客户信息
        order_type: "", // model-客户信息
        cardMust: 0, // 证件是否必须 0 -1
        visitorList: {}, // 全部联系人列表
        distributor: {}, // 获取经销商信息

        goods_id: this.$route.query.goods_id, // 商品id
        disabled: false, // 订单提交时按钮状态
        totalPrice: 0, // 计算后的商品价格
        selectItem: {}, // 选中日期 dd
        use_date: "", //选中的日期 dd.date
        beg_Date: "", //起始日期
        deDataP: { // 初始化自定义的时间范围
          defaultPrice: "", // 价格
          defaultStock: 0, // 余
          Dates: [] // 日期范围
        },
        iscalender: false, // 控制是否显示日期组件

        remarks: "", // model - 备注
        detail: null, // 商品详情
        getGoodsSkusPrice: [], // 下单页sku
        skupricedata: [], // 价格计算
        columns: [], // 证件类型
      };
    },
    created() {
      this.distributor = this.$store.getters.getDistributor;
    },
    mounted() {
      this.$nextTick(() => {
        this.axios_Request_detail();
        this.axios_Request_sku();
        this.deDataP.Dates = this.getThreeMonthsLaterDates(); // 获取日期传入日历组件
        this.iscalender = true;
        this.getCardTypeList();
      })
    },
    methods: {
      // 获取证件类型
      getCardTypeList() {
        let url = "/addons/litestore/api.player/getCardTypeList";
        util.get(url, {}, (res) => {
          this.columns = this.convertToData(res.data);
        });
      },
      // 对象转数组
      convertToData(data) {
        let data2 = [];
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            data2.push({
              text: data[key],
              value: key
            });
          }
        }

        return data2;
      },
      // 获取商品信息
      axios_Request_detail() {
        var url = "/addons/litestore/api.goods/detail"
        let that = this;
        //这里直接调用网络接口
        util.get(url, {
            'goods_id': that.goods_id
          },
          function(result) {
            // if (result.data.detail.spec_type === '20') {
            //goods 基本信息
            let meta = result.data.detail.meta;
            that.isOne = meta.player_rule;
            that.order_type = that.isOne; // 10单 20 30
            that.cardMust = meta.card_must; // 证件是否必须
            that.detail = result.data.detail; // 商品详情
            //   }
          },
        );
      },
      // 获取商品sku
      axios_Request_sku(date, radio) {
        var url = "/addons/litestore/api.goods/getGoodsSkusPrice";
        let that = this;
        let time = new Date();
        let param = {
          goods_id: that.goods_id,
          use_date: date ? date : that.formatDate(time, 'y-m-d') //'2023-12-29' //that.formatDate(time, 'y-m-d')
        };
        //这里直接调用网络接口
        util.get(url, param, function(result) {
          let array = [];
          let object = result.data;
          let index = 0;
          for (const i in object) {
            if (Object.hasOwnProperty.call(object, i)) {
              index++;
              const item = object[i];
              item.index = index + '';
              item.group_id = item.group_id + '';
              array.push(item);
            }
          }
          that.$nextTick(() => {
            that.getGoodsSkusPrice = array;
            if (radio) {
              // 重新计算价格
              that.skulistpriceReset();
            }
          })
        });
      },
      // 改变日期时重新计算价格
      skulistpriceReset() {
        if (this.skupricedata.length > 0) {
          this.skupricedata = this.updateSkulistPrice(this.skupricedata, this.getGoodsSkusPrice)
          this.totalPrice = this.calculateTotalPrice(this.skupricedata);
        }
      },
      updateSkulistPrice(skulistprice, cardMust) {
        const updatedSkulistPrice = skulistprice.map((sku) => {
          const correspondingCardGroup = cardMust.find((cardGroup) => {
            return sku.groupid === cardGroup.group_id && sku.id === cardGroup.items[0].spec_sku_id && sku
              .skulistprice !== cardGroup.items[0].price;
          });
          if (correspondingCardGroup) {
            return {
              ...sku,
              skulistprice: correspondingCardGroup.items[0].price,
            };
          } else {
            return sku;
          }
        });
        return updatedSkulistPrice;
      },
      // 和初始的sku数组列表对比后给价格重新赋值
      // 当前日期后三天，和三个月后的最后一天日期
      getThreeMonthsLaterDates() {
        // 获取当前日期
        let currentDate = new Date();
        // 计算三个月后的日期
        let threeMonthsLaterDate = new Date(currentDate);
        threeMonthsLaterDate.setMonth(currentDate.getMonth() + 3);
        // 构造包含前三天日期和三个月后的日期的数组
        let combinedDates = [];
        // 添加当前日期开始的前三天日期
        for (let i = 0; i < 3; i++) {
          let previousDate = new Date(currentDate);
          previousDate.setDate(currentDate.getDate() + i);
          const formattedDate = this.formatDate(previousDate, 'y/m/d');
          combinedDates.push({
            year: previousDate.getFullYear(),
            month: previousDate.getMonth() + 1,
            day: previousDate.getDate(),
            date: formattedDate
          });
        }
        // 添加三个月后的日期
        const formattedDate = this.formatDate(threeMonthsLaterDate, 'y/m/d');
        combinedDates.push({
          year: threeMonthsLaterDate.getFullYear(),
          month: threeMonthsLaterDate.getMonth() + 1,
          day: threeMonthsLaterDate.getDate(),
          date: formattedDate
        });
        return combinedDates;
      },
      // 获取指定的日期格式
      formatDate(date, type) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        let str = '';
        if (type == 'y/m/d') {
          str = `${year}/${month}/${day}`;
        }
        if (type == 'y-m-d') {
          str = `${year}-${month}-${day}`;
        }
        return str
      },
      updateCardType(visitor, columns) {
        for (const item of visitor) {
          for (const subItem of item.visitor) {
            const matchingColumn = columns.find(column => column.text === subItem.card_type);
            if (matchingColumn) {
              subItem.card_type = matchingColumn.value;
            }
          }
        }
        return visitor
      },
      convertToGoodsObject(visitor) {
        let goods = {};

        for (const item of visitor) {
          const skuId = item.spec_sku_id;

          if (!goods[skuId]) {
            goods[skuId] = {
              goods_price: item.goods_price,
              total_num: 0,
              visitor: []
            };
          }

          goods[skuId].total_num += item.total_num;

          for (const visitorItem of item.visitor) {
            goods[skuId].visitor.push({
              contacts: visitorItem.contacts,
              telephone: visitorItem.telephone,
              card_type: visitorItem.card_type,
              IDCard: visitorItem.IDCard
            });
          }
        }

        return goods;
      },
      // 提交订单
      onSubmit() {
        let that = this;
        // if (!that.totalPrice) {
        //   that.$toast.fail("商品数量不能为0");
        //   return false;
        // }
        if (!that.use_date) {
          that.$toast.fail("请选择日期");
          return false;
        }
        let isAllWrite = this.verifyTourist(this.visitorList, this.cardMust);
        if (!isAllWrite) {
          that.$toast.fail("请填写全部客户信息");
          return false;
        }
        if (that.disabled) {
          return false;
        }
        if (that.distributor != null && that.distributor.status != "normal") {
          Dialog.alert({
            title: "温馨提示",
            message: "请先申请为分销商"
          }).then(() => {
            // 返回首页
            //   that.$router.push("/My");
            // on close
          });
          return false;
        }
        // use_date 使用时间
        // goods_id 商品ID
        // goods_sku_id
        // visitor 游客处理 this.visitorList this.skupricedata
        let visitor = this.visitorAndPrice(this.visitorList, this.skupricedata);
        visitor = this.updateCardType(visitor, this.columns)
        that.disabled = true;
        //http://www.shop.lol/addons/litestore/api.order/booking
        var url = '/addons/litestore/api.order/booking' //"/addons/litestore/api.order/submit";
        var param = {
          goods_id: that.goods_id,
          use_date: that.use_date,
          order_type: that.order_type,
          remarks: that.remarks,
          goods: this.convertToGoodsObject(visitor), // 转换为对象
        };
        util.post(
          url,
          param,
          function(result) {
            that.disabled = false;
            //return false;
            if (result.code == 1008) {
              //这里不直接跳转了，提示框  为绑定微信，跳转到my页面 绑定微信
              that.$dialog
                .confirm({
                  title: "未通过微信登录",
                  message: "您的账号未绑定微信号，请跳转后绑定微信号再进入未支付订单继续支付。"
                })
                .then(() => {
                  that.$router.push({
                    path: "/My"
                  });
                })
                .catch(() => {
                  util.redirect("myorder/list?showType=0");
                });
            } else {
              //这里发起支付
              that.$dialog
                .confirm({
                  title: "温馨提示",
                  message: result.msg,
                  //"下单成功，超时未支付，系统将自动取消订单，再购须重新下单。",
                  showCancelButton: false
                })
                .then(() => {
                  util.redirect("disorder?showType=0");
                });
            }
          },
          function(result) {
            console.log(result);
          },
          function() {
            that.disabled = false;
          }
        );
      },
      // 单选 一人一证/一人多证
      onRadio(e) {
        this.order_type = e
      },
      /*********************子组件触发*************************** */
      // 当数量改变时触发
      ChangeNum(skuprice) {
        let skupricedata = this.addOrUpdateObjectById(skuprice);
        skupricedata.forEach((item, index) => {
          if (item.num == 0) {
            // 删除游客
            this.deletevisitorList(item.id)
            skupricedata.splice(index, 1)
          }
        })
        this.skupricedata = skupricedata;
        this.totalPrice = this.calculateTotalPrice(this.skupricedata);
      },
      // 删除游客
      deletevisitorList(id) {
        let object = this.visitorList;
        for (const key in object) {
          if (Object.hasOwnProperty.call(object, key)) {
            //const item = object[key];
            if (key == id) {
              delete object[key]
            }
          }
        }
      },
      // 添加对象到数组中 根据id判断是否重复 重复则替换为新的对象
      addOrUpdateObjectById(newObj) {
        let newArray = this.skupricedata; // 创建数组的副本以保持原数组不变
        // 查找数组中是否存在相同 ID 的对象
        let index = newArray.findIndex(obj => obj.id === newObj.id);
        // 如果存在相同 ID 的对象，则替换；否则，添加新对象到数组
        if (index !== -1) {
          newArray[index] = newObj;
        } else {
          newArray.push(newObj);
        }
        return newArray;
      },
      // 计算总价格
      calculateTotalPrice(array) {
        return array.reduce((total, obj) => {
          // 如果 num 大于 0，则将 num * skulistprice 累加到总值
          if (obj.num > 0) {
            total += obj.num * parseFloat(obj.skulistprice);
          }
          return total;
        }, 0); // 初始值设置为 0
      },
      // 当日期改变时
      confirm(item) {
        this.totalPrice = 0;
        this.selectItem = item.dd;
        this.use_date = item.dd.date;
        this.axios_Request_sku(item.dd.date, 'radio')

      },
      // 选择游客时触发
      YkSubmit(items, skuid) {
        this.visitorList[skuid] = items;
        let obj = this.visitorList;
        for (const key in obj) {
          if (obj[key] instanceof Array && obj[key].length === 0) {
            delete obj[key];
          }
        }
      },
      // 去重处理
      removeDuplicates(array, id) {
        const uniqueObjects = {};

        // 遍历数组中的每个对象
        for (const obj of array) {
          // 获取对象的 skuid 属性值
          const skuid = obj[id];

          // 如果对象的 skuid 已存在，覆盖之前的对象
          if (uniqueObjects.hasOwnProperty(skuid)) {
            uniqueObjects[skuid] = obj;
          } else {
            // 如果 skuid 不存在，添加到唯一对象中
            uniqueObjects[skuid] = obj;
          }
        }

        // 将唯一对象的值转换为数组返回
        const uniqueArray = Object.values(uniqueObjects);

        return uniqueArray;
      },
      // 验证游客是否有空的

      verifyTourist(v, cardMust) {
        for (const key in v) {
          if (v.hasOwnProperty(key)) {
            const items = v[key];
            for (let i = 0; i < items.length; i++) {
              const item = items[i];
              if (
                !item.contacts ||
                !item.telephone ||
                (cardMust === 1 && (!item.IDCard || item.IDCard === null || !item.card_type || item.card_type === null))
              ) {
                return false;
              }
            }
          }
        }
        return true;
      },
      // 合并为新数组
      visitorAndPrice(obj, array) {
        const result = [];

        for (const item of array) {
          const id = item.id;
          const skulist = obj[id];

          if (skulist) {
            const skulistprice = item.skulistprice;
            const visitors = skulist.map(visitor => ({
              ...visitor
            }));

            const newItem = {
              total_num: item.num,
              spec_sku_id: id,
              goods_price: skulistprice,
              visitor: visitors
            };

            result.push(newItem);
          }
        }

        return result;
      }
    },
    watch: {
      // 经销商
      "$store.state.distributor"() {
        this.distributor = this.$store.getters.getDistributor;
      },
    }
  };
</script>

<style lang="less" scoped>
  .catcheck {
    height: 100%;
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 18;

    /deep/ .cube-page>.wrapper {
      background-color: #edeff4;

      .content {
        margin: 0;
      }
    }

    // 设置手风琴样式
    /deep/ .collapse-zdy>.van-collapse-item>.van-cell {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .content-order {
    padding: 15px 15px 80px;

    .content-main {
      background: #fff;
      margin-bottom: 15px;
      overflow: hidden;
      border-radius: 8px;

      .leoAddLkclass {
        .title-top {
          font-size: 16px;
          color: #333;
          font-weight: bold;
          padding: 15px;
        }

        .yktitle {
          padding: 15px 15px;
          display: flex;
          align-items: center;
          background-color: #fff;

          .title {
            font-size: 16px;
            font-weight: 600;
          }

          .rematk {
            margin-left: 15px;
            font-size: 12px;
          }
        }
      }
    }

    .collapse-zdy {
      border-radius: 8px;
      overflow: hidden;

      .ddcheck {
        margin: 0 auto;
        margin-bottom: 15px;

        .introduction {
          padding: 0;

          .introduction-main {
            color: #333;
            padding-bottom: 10px;
            padding-top: 10px;
            border-bottom: 1px solid #ddd;

            .introduction-title {
              font-size: 16px;
              font-weight: bold;
              color: #333;
              padding-left: 15px;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .right {
                color: #ee0a24;
              }

              .no {
                font-size: 14px;
              }
            }
          }

          .introduction-main:first-of-type {
            padding-top: 0;
          }

          .introduction-main:last-of-type {
            border-bottom: none;
            padding-bottom: 0;
          }
        }
      }
    }
  }
</style>
